import React from "react"
import PropTypes from "prop-types"
import ReactDropzone from "react-dropzone"
import request from "superagent"
import axios from "axios"
import { Link } from "react-router-dom"

class Image extends React.Component {
  constructor(props) {
    super(props);
    // this.loadImages = this.loadImages.bind(this)
    this.purge = this.purge.bind(this)
    this.state = {
      files: [],
      images: [],
      preview: false,
      loading: false,
      done: false
    };
  }
  componentDidMount(){
    this.loadImages()
  }

  purge(){
  }
  loadImages(){
  }
  onPreviewDrop = (files) => {
    this.setState({
      files: files,
      preview: true,
      loading: true
     });
    var that = this

    const req = request.post('/api/v1/bien/uploadImage');
    var sendfiles = []
    files.forEach(file => {
      req.attach("images["+file.name+"]", file);
    });
    req.field("id",this.props.bien.id)
    req.end((err,res)=>{
      that.setState({
        loading: false,
        done: true
      })
    });
  }

  render() {
    const previewStyle = {
      display: 'inline',
      width: 200,
      height: 200,
    };

    return (
      <div className="app">
        {this.props.isimage ? (
            <h1 className="center">Changer l'image</h1>
          ) : (
            <h1 className="center">Ajouter une image (facultatif)</h1>

          )}
        <div className="row">
        {this.state.done &&
          <h2 className="green-text container">L'image a bien été enregistrée</h2>
        }
          <div className="col s4 offset-s1">
            <div className="">
            { this.state.preview ? (
              <div>
                {this.state.files.length > 0 &&
                  <React.Fragment>
                    <h3>Previews</h3>
                    {this.state.files.map((file) => (
                      <img
                        alt="Preview"
                        key={file.preview}
                        src={file.preview}
                        style={previewStyle}
                      />
                    ))}
                </React.Fragment>
                }
            </div>
            ) : (
              <div>
                {this.props.isimage ? (
                  <img className="responsive-img" src={this.props.image} alt=""/>
                  ) : (
                  <div></div>
                  )}
              </div>
            )}
          </div>
          </div>
          <div className="col s5 center ">
          {this.state.loading ? (
              <div>
                <p>Upload de l'image en cours</p>
              </div>
            ) : (
              <ReactDropzone
                accept="image/*"
                onDrop={this.onPreviewDrop}
                multiple={false}
                maxSize={500000}
              >
               <h2> amenez l'image ici !</h2>
              </ReactDropzone>

            )}


          </div>

          <div className="col s2">
            <a href="/proprietaires/biens/index" className="btn btn-large">Terminer</a>
          </div>
        </div>
        <div className="row">

        </div>
      </div>
    );
  }
}

export default Image
